import React, { useState } from 'react';
import { Typography, Table, TableHead, TableRow, TableCell, TableBody, Paper, TableContainer } from '@mui/material';
import DateRangeFilter, { defaultStart, defaultEnd } from './DateRangeFilter';
import { ReportReasons } from '../../../api';

const ReasonsReport = ({ access }) => {
  const [start, setStart] = useState(defaultStart());
  const [end, setEnd] = useState(defaultEnd());
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);

  const run = () =>
    ReportReasons(access?.org?.id, { start, end }).then(data => {
      setRows(data.rows || []);
      setTotal(data.total || 0);
    }).catch(() => {});

  return (
    <>
      <Typography variant="h6" sx={{ mb: 2 }}>Reason / Subreason Counts</Typography>
      <DateRangeFilter start={start} end={end} onStart={setStart} onEnd={setEnd} onSubmit={run} />
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Reason</TableCell>
              <TableCell>Subreason</TableCell>
              <TableCell align="right">Count</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((r, i) => (
              <TableRow key={i}>
                <TableCell>{r.reason}</TableCell>
                <TableCell>{r.subreason || '—'}</TableCell>
                <TableCell align="right">{r.count}</TableCell>
              </TableRow>
            ))}
            {!rows.length && <TableRow><TableCell colSpan={3} align="center">No results</TableCell></TableRow>}
            {!!rows.length && (
              <TableRow>
                <TableCell colSpan={2}><strong>Total</strong></TableCell>
                <TableCell align="right"><strong>{total}</strong></TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default ReasonsReport;
